module.exports = __webpack_public_path__ + "img/category-popular.29db90f8.png";